import { NavLink } from 'react-router-dom'
import { BranchHistoryIcon, InfoCircleIcon, PaperclipIcon } from '@/components/icons'
import { cn } from '@/lib/utils'

const sections = [
  { path: 'config', label: 'Config', Icon: InfoCircleIcon },
  { path: 'attachments', label: 'Attachments', Icon: PaperclipIcon },
  { path: 'version-history', label: 'Version History', Icon: BranchHistoryIcon },
]

export function SkillSectionsNav() {
  return (
    <nav className="w-[240px] shrink-0 rounded-2xl border border-border bg-card" aria-label="Skill sections" data-testid="skill-sections-nav">
      <p className="border-b border-border px-4 py-4 text-lg font-bold leading-[1.3] text-foreground">Skill sections</p>
      <ul className="space-y-1 p-2">
        {sections.map(({ path, label, Icon }) => (
          <li key={path}>
            <NavLink
              to={path}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors',
                  isActive ? 'bg-card-foreground font-semibold text-card' : 'text-foreground hover:bg-muted',
                )
              }
              data-testid={`skill-section-link-${path}`}
            >
              <Icon className="h-5 w-5 shrink-0" />
              {label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  )
}
